// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"252":"896978cb","878":"65bdad6b","1142":"65bdad6b","3070":"01b41cc2","4158":"e74b5f33"}[chunkId] + ".css";
};